import React from 'react';

const Address = ({ time, address, isLast }) => {
    return (
        <div className="timelineStop">
            <div className="timelineStop__time">{time}</div>
            <div className="timelineStop__iconWrapper">
                <div className={`timelineStop__circle ${isLast ? 'filled' : ''}`} />
                {!isLast && <div className="timelineStop__line" />}
            </div>
            <div className="timelineStop__address">{address}</div>
        </div>
    );
};

export default Address;